module.exports = "/static/assets/942a669c040a4579e548cea4caaf933c.png";